export const splitId = (idToSplit: string) => {
  return idToSplit.split(':')[1];
};
